type ArrowRightProps = {
  className?: string;
  fill?: string;
};

const ArrowRight = ({ className, fill }: ArrowRightProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      id="ArrowRightVector"
      d="M4.99953 13L16.1695 13L11.2895 17.88C10.8995 18.27 10.8995 18.91 11.2895 19.3C11.6795 19.69 12.3095 19.69 12.6995 19.3L19.2895 12.71C19.6795 12.32 19.6795 11.69 19.2895 11.3L12.7095 4.7C12.3195 4.31 11.6895 4.31 11.2995 4.7C10.9095 5.09 10.9095 5.72 11.2995 6.11L16.1695 11L4.99953 11C4.44953 11 3.99953 11.45 3.99953 12C3.99953 12.55 4.44953 13 4.99953 13Z"
      fill={fill}
    />
  </svg>
);

export default ArrowRight;
